import { render, staticRenderFns } from "./Izdatnica.vue?vue&type=template&id=0e60bc31&"
import script from "./Izdatnica.vue?vue&type=script&lang=ts&"
export * from "./Izdatnica.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports